import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';
import { environment } from '../../environments/environment';
import { SecretService } from './secret.service';
// import { AppConfig } from './config/app.config';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  baseUrl: any;
  // siteBaseUrl: any;
  constructor(private http: HttpClient, private secretServ: SecretService) {
    this.baseUrl = environment.baseUrl;
    // this.siteBaseUrl = environment.siteBaseUrl;
  }

  /**
   * Service for register the tanent of CM.
   * Created by Rashmi Ranjan
   * @Phantom
   * CreatedOn 03-Dec-2021
   */
  listAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-admin-user', payload);
  }
  archivedStaffList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/deleted-staff-list', payload);
  }
  restoreStaff(staffId: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${staffId}/restore-staff`, {});
  }
  
  // viewUser(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/view-user');
  // }
  viewUserId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-user', payload);
  }
  addAdminUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-admin-user', payload);
  }
  deleteUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-user', payload);
  }
  updateUserStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-user-status', payload);
  }
  bulkUpdateUser(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-user', payload);
  }
  getSupervisorList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-supervisor-user');
  }
  getEngineerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-engineer-user');
  }
  // getClientList(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'user/list-client-user');
  // }
  getClientList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-clients');
  }
  getActiveUsersCount(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-active-user-count');
  }

  // other users list
  getAllOtherUsers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-other-user');
  }

  getCountryList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/list-country', payload);
  }

  getCurrencyList(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'master/get-currency-list', payload);
  }
  changeImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }
  deleteImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/change-profile-pic', payload);
  }

  /** client managemant */
  // addClientUser(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/save-client-user', payload);
  // }
  // getClientlist(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/get-client-list', payload);
  // }
  // viewClientlist(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/view-client', payload);
  // }
  // viewClientInfo(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/view-client-info', payload);
  // }
  // updateClientStatus(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/update-client-status', payload);
  // }
  // deleteClient(payload: any): Observable<any> {
  //   return this.http.post(this.baseUrl + 'user/delete-client', payload);
  // }
  // bulkUpdateClient(payload: any): Observable<any> {
  //   return this.http.post(
  //     this.baseUrl + 'user/bulk-update-client-status',
  //     payload
  //   );
  // }

  saveSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-supervisor-user', payload);
  }
  getSupervisors(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/get-supervisors', payload);
  }
  viewSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-supervisor', payload);
  }
  deleteSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-supervisor', payload);
  }
  updateSupervisorStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-supervisor-status',
      payload
    );
  }
  bulkUpdateSupervisor(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-supervisor',
      payload
    );
  }

  saveAreaManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/save-area-manager-user',
      payload
    );
  }
  getAreaManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-area-managers');
  }
  viewAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-area-manager', payload);
  }
  deleteAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-area-manager', payload);
  }
  updateAreaManagerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-area-manager-status',
      payload
    );
  }
  bulkUpdateAreaManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-area-manager-status',
      payload
    );
  }

  saveEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-engineer-user', payload);
  }
  getEngineers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/get-engineers');
  }
  viewEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/view-engineer', payload);
  }
  deleteEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/delete-engineer', payload);
  }
  updateEngineerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-engineer-status',
      payload
    );
  }
  bulkUpdateEngineer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/bulk-update-engineer', payload);
  }

  updateImage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-image', payload);
  }
  updatePassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/update-password', payload);
  }
  resetPassword(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/resetPassword', payload);
  }
  sendQRViaEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/sendQRbyEmail', payload);
  }
  showQR(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/singleUserQR', payload);
  }

  getSamClient(): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsClientBE', {});
  }

  getSamSite(country_code: any, sage_no: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/fetch-CD-ccsSitesBE', {
      country_code,
      sage_no,
    });
  }

  forgotPass(payload: { email: string }): Observable<any> {
    // console.log(payload);
    return this.http.post(this.baseUrl + 'user/forgot-password', payload);
  }

  resetNewPassword(
    email: string,
    token: string,
    newPassword: string
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'user/reset-new-password', {
      email,
      token,
      newPassword,
    });
  }

  sendContact(): Observable<any> {
    return this.http.post(this.baseUrl + 'user/send-request-by-email ', {
      _id: this.secretServ.decryptLocalStorageData(
        localStorage.getItem('user_id')
      ),
      email: this.secretServ.decryptLocalStorageData(
        localStorage.getItem('emailId')
      ),
    });
  }

  importSupervisor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-supervisor', payload);
  }

  importAreaManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-area-manager', payload);
  }

  importClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/import-client', payload);
  }

  clientSync(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/clientSyncAllData', payload);
  }

  saveOperationManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/save-operation-manager-user',
      payload
    );
  }

  saveRole(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/role-change-Users', payload);
  }
  // http://localhost:8000/auth/api/v1/user/role-change-Users

  listOperationManagers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-operation-manager-user');
  }

  deleteOperationManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/delete-operation-manager-user',
      payload
    );
  }

  updateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/update-operation-manager-status',
      payload
    );
  }

  bulkUpdateOperationManagerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/bulk-update-operation-manager-status',
      payload
    );
  }

  countryWiseClientList(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'user/country-wise-client-list',
      payload
    );
  }

  listAllClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/list-all-client', payload);
  }

  listSuperAdminUser(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-super-admin-user');
  }

  clientSupportTicket(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/client-support-ticket', payload);
  }

  /****** Support Manager *******/
  saveSupportManager(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/save-support-manager', payload);
  }

  listSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/list-support-manager');
  }

  listActiveSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'master/support-manager-dropdown-list');
  }

  checkClientQEHS(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/check-client-qehs', payload);
  }

  roleDropdownList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'master/role-dropdown-list', payload);
  }

  syncAllAdmin(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/adminSyncAllData');
  }

  syncAllOpManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/OMSyncAllData');
  }

  syncAllSupportManager(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/SMSyncAllData');
  }

  getCalendarData(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'user/fetch-calender', payload);
  }

  getBCCompanyList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/BC-companyList');
  }

  getVanTrackingCustomerList(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/vanTracking-customerList');
  }

  getVanTrackingDeviceLocation(
    payload: any,
    accessToken: any,
    token: any
  ): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        authorization: `Bearer ${accessToken}, Token ${token}`,
      }),
    };
    return this.http.post(
      this.baseUrl + 'user/vanTracking-customer-device-Location',
      payload,
      httpOptions
    );
  }

  getAllSiteAM(data: any) {
    const payload = { am_emails: [...data] };
    return this.http.post(this.baseUrl + 'user/get-all-site-ams', payload);
  }

  getAllRoles() {
    return this.http.get(this.baseUrl + 'user/all-roles');
  }

  getAllStockWarehouse() {
    return this.http.get(this.baseUrl + 'master/get-stock-warehouse-list');
  }
  createMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machine', payload);
  }
  machineList(params?: any) {
    const queryParams: any = {};
    if (params?.manufacturerId) {
      queryParams.manufacturerId = params.manufacturerId;
    }
    if (params?.machineTypeId) {
      queryParams.machineTypeId = params.machineTypeId;
    }
    return this.http.get(this.baseUrl + 'machine/get-machine-list', { params: queryParams });
  }
  deleteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machine', payload);
  }
  deleteMachineInstance(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machine-instance', payload);
  }
  updateMachineStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-machine-status',
      payload
    );
  }
  getMachineDetails(machineId: string) {
    return this.http.get(
      this.baseUrl + `machine/get-machine-details/${machineId}`
    );
  }
  bulkUpdateMachine(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-update-machine',
      payload
    );
  }
  addContract(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-contract', payload);
  }
  contractList(params?: any) {
    const queryParams: any = {};
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'manageClient/get-contract-list', {
      params: queryParams,
    });
  }
  deleteContract(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/delete-contract',
      payload
    );
  }
  updateContractStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/update-contract-status',
      payload
    );
  }
  bulkUpdateContract(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/bulk-update-contract',
      payload
    );
  }
  getContractDetails(contractId: string) {
    return this.http.get(
      this.baseUrl + `manageClient/get-contract-details/${contractId}`
    );
  }
  addSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-sector', payload);
  }
  sectorList(params?: any) {
    const queryParams: any = {};
    if (params?.contractId) {
      queryParams.contractId = params.contractId;
    }
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'manageClient/get-sector-list', {
      params: queryParams,
    });
  }
  deleteSector(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/delete-sector', payload);
  }
  updateSectorStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/update-sector-status',
      payload
    );
  }
  bulkUpdateSector(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/bulk-update-sector',
      payload
    );
  }
  getSectorDetails(sectorId: string) {
    return this.http.get(
      this.baseUrl + `manageClient/get-sector-details/${sectorId}`
    );
  }
  /** client managemant */
  addClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/add-client', payload);
  }
  clientList() {
    return this.http.get(this.baseUrl + 'manageClient/get-client-list');
  }
  deleteClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'manageClient/delete-client', payload);
  }
  updateClientStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/update-client-status',
      payload
    );
  }
  bulkUpdateClient(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'manageClient/bulk-update-client',
      payload
    );
  }
  getClientDetails(clientId: string) {
    return this.http.get(
      this.baseUrl + `manageClient/get-client-details/${clientId}`
    );
  }

  /* Site Staff */
  saveSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/save-site', payload);
  }

  // getAllSite(): Observable<any> {
  //   return this.http.get(this.baseUrl + 'site/get-all-site');
  // }
  getAllSite(params?: any) {
    const queryParams: any = {};
    if (params?.cityName) {
      queryParams['cityName'] = params.cityName;
    }
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    if (params?.countryId) {
      queryParams.countryId = params.countryId;
    }
    return this.http.get(this.baseUrl + 'site/get-all-site', {
      params: queryParams,
    });
  }

  siteStatusChange(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/site-status-change', payload);
  }

  getSingleSite(params: { _id: string }) {
    const queryParams: { _id: string } = {
      _id: params._id ? params._id : ''
    };
    return this.http.get(this.baseUrl + 'site/get-single-site', { params: queryParams });
  }

  getAreaManagerList(params?: any) {
    const queryParams: any = {};
    if (params?.clientId) {
      queryParams.clientId = params.clientId;
    }
    return this.http.get(this.baseUrl + 'site/get-areaManager-list', {
      params: queryParams,
    });
  }

  getCity(clientId: string, countryIds: string): Observable<any> {
    const queryParams = new HttpParams()
      .set('clientId', clientId)
      .set('countryIds', countryIds);

    return this.http.get(this.baseUrl + 'site/get-city', { params: queryParams })

  }
  updateAreaManager(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'site/update-site-area-manger',
      payload
    );
  }
  addManufacturer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-manufacturer', payload);
  }
  getAllManufacturer() {
    return this.http.get(this.baseUrl + 'machine/get-manufacturer-list');
  }
  deleteManufacturer(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-manufacturer', payload);
  }
  updateManufacturerStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-manufacturer-status',
      payload
    );
  }
  bulkUpdateManufacturer(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-update-manufacturer',
      payload
    );
  }
  getManufacturerDetails(manufacturerId: string) {
    return this.http.get(
      this.baseUrl + `machine/get-manufacturer-details/${manufacturerId}`
    );
  }

  addMachineType(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machinetype', payload);
  }
  getAllMachineType() {
    return this.http.get(this.baseUrl + 'machine/get-machine-type-list');
  }
  deleteMachinetype(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-machinetype', payload);
  }
  updateMachinetypeStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-machinetype-status',
      payload
    );
  }
  bulkUpdateMachinetype(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/bulk-update-machinetype',
      payload
    );
  }
  getMachinetypeDetails(machinetypeId: string) {
    return this.http.get(
      this.baseUrl + `machine/get-machinetype-details/${machinetypeId}`
    );
  }
  getAllSiteMachineDetails(site_id: string) {
    return this.http.get(
      this.baseUrl + `machine/get-site-machine-details/${site_id}`
    );
  }

  addSiteMachine(payload: any) {
    return this.http.post(
      this.baseUrl + 'machine/add-machine-fields', payload
    );
  }

  deleteSiteMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-site-machine', payload);
  }


  // Devadatta
  getClientsAc(payload: any): Observable<any> {
    console.log(">>>>>>>>>>>>>>>>", payload);
    return this.http.post(this.baseUrl + 'manageClient/get-client-list-ac', payload);
  }

  getNextJobID() {
    return this.http.post(this.baseUrl + 'jobs/get-next-job-id', {});
  }
  getClientContractList(clientId: string) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/contracts`, null);
  }
  getClientCountryList(clientId: string) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/countries`, null);
  }

  getClientSiteList(clientId: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client/${clientId}/sites`, params);
  }
  getMultiClientSiteList(clientIds: string, params?: any) {
    return this.http.post(this.baseUrl + `manageClient/client-sites`, {
      clientIds,
      ...params
    });
  }

  createJob(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/create', payload);
  }

  getJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-jobs', payload);
  }
  getExportJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/export-jobs', payload);
  }

  getJobDetails(jobId: string, params?: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/details`, params);
  }
  updateJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/update`, payload);
  }

  importSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'site/save-bulk-site', payload);
  }

  importBulkMachineSite(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/import-site-machine', payload);
  }

  deleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/delete`, {});
  }

  attachJobImages(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/attach-images`, payload);
  }

  // get all machines of a site
  fetchSiteMachines(siteId: string) {
    return this.http.post(this.baseUrl + `jobs/get-site-machines/${siteId}`, {});
  }

  attachMachineToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/attach-a-machine`, payload);
  }

  detachMachineFromJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/detach-a-machine`, payload);
  }

  // job machines
  getJobMachines(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/machines`, {});
  }
  // assign-engineer
  assignEngineerToJob(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/assign-engineer`, payload);
  }
  // getAllEngineersForJob
  getAllEngineersForJob(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/available-engineers`, {});
  }
  
  // getAllEngineersForMultiStepJob
  getAllEngineersForMultiStepJob(payload: { siteId?: string } = {}) {
    return this.http.post(this.baseUrl + 'jobs/all-engineers', payload);
  }

  // getAssignedEngineerLogs
  getAssignedEngineerLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/assigned-engineer-logs`, {});
  }
  // Job Logs
  getJobLogs(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/logs`, {});
  }

  // all statuses
  getAllStatuses() {
    return this.http.get(this.baseUrl + 'jobs/job-statuses');
  }

  // change job status
  changeJobStatus(jobId: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/change-status`, payload);
  }


  getDeletedJobsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-deleted-jobs', payload);
  }

  // restoreJob
  restoreJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/restore`, {});
  }
  // permanentDeleteJob
  permanentDeleteJob(jobId: string): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/${jobId}/permanent-delete`, {});
  }

  getSiteJobDetails(siteId: string, payload: any) {
    return this.http.post(
      this.baseUrl + `jobs/get-site-jobs/${siteId}`, payload);
  }

  // work-sessions
  getWorkSessions(jobId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions`, {});
  }

  // session-info
  getSessionInfo(jobId: string, sessionId: string) {
    return this.http.post(this.baseUrl + `jobs/${jobId}/work-sessions/${sessionId}/info`, {});
  }








  getManufacturerAc(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/get-manufacturer-list-ac', payload);
  }

  getOpenedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-opened-jobs', payload);
  }

  getCompletedJobsListForDashboard(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-completed-jobs', payload);
  }

  getDashboardJobs(listType: string, limit: number, params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', { listType, limit, ...params });
  }

  getDashboardJobs2(params: object = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/get-dashboard-jobs', { ...params });
  }

  errorList(params?: any) {
    return this.http.get(this.baseUrl + 'jobs/get-error-list', params);
  }

  addMachineService(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/add-machine-service', payload);
  }

  getMachineServiceDetails(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-service-details/${id}`);
  }

  getJobServiceDetails(jobId: string): Observable<any> {
    return this.http.get(this.baseUrl + `machine/get-job-service-details/${jobId}`);
  }

  deleteServiceDetails(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'machine/delete-service-details', payload);
  }

  eolMachineList(params?: any) {
    const queryParams: any = {};
    if (params?.site_id) {
      queryParams.site_id = params.site_id;
    }
    if (params?.machine_id) {
      queryParams.machine_id = params.machine_id;
    }
    return this.http.get(this.baseUrl + 'machine/get-eol-machine-list', { params: queryParams });
  }

  updateEolMachineStatus(payload: any): Observable<any> {
    return this.http.post(
      this.baseUrl + 'machine/update-eol-machine-status',
      payload
    );
  }

  //Restore client
  restoreClient(clientId: string): Observable<any> {
    return this.http.post(this.baseUrl + `client/${clientId}/restore`, {});
  }

  //Permanently delete client
  hardDeleteClient(clientId: string): Observable<any> {
    return this.http.post(this.baseUrl + `client/${clientId}/hard-delete`, {});
  }

  //Bulk permanently delete clients
  bulkDeleteClient(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'client/bulk-delete-documents', payload);
  }

  //Deleted client list
  deletedClientList(payload: any) {
    return this.http.post(this.baseUrl + 'client/get-deleted-clients', payload);
  }

  //Send email
  sendEmail(clientId: string): Observable<any> {
    return this.http.post(this.baseUrl + `client/${clientId}/send-email`, {});
  }

   //Send Forms
   sendForm(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `client/send-forms`, payload);
  }

  // Form Management
  createFormApi(payload: any) {
    return this.http.post(this.baseUrl + 'form/save-form', payload);
  }

  listFormApi(payload: any) {
    return this.http.post(this.baseUrl + 'form/form-list', payload);
  }

  singleViewFormApi(formID: any) {
    return this.http.get(this.baseUrl + `form/get-form-details/${formID}`);
  }

  deleteForm(formID: any) {
    return this.http.post(this.baseUrl + `form/delete-form/${formID}`, {});
  }

  updateFormStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'form/update-form-status', payload);
  }

  bulkUpdateForm(payload: any) {
    return this.http.post(this.baseUrl + 'form/bulk-update-form', payload);
  }

  restoreForm(formId: string): Observable<any> {
    return this.http.post(this.baseUrl + `form/${formId}/restore-form`, {});
  }

  archivedFormList(payload: any) {
    return this.http.post(this.baseUrl + 'form/archived-forms', payload);
  }

  hardDeleteForm(formId: string): Observable<any> {
    return this.http.post(this.baseUrl + `form/${formId}/hard-delete`, {});
  }



  //ADHD Client Management
  createClientApi(payload: any) {
    return this.http.post(this.baseUrl + 'client/add-client', payload);
  }

  listClientApi(payload: any) {
    return this.http.post(this.baseUrl + 'client/client-list', payload);
  }

  singleClientViewFormApi(clientID: any) {
    return this.http.get(this.baseUrl + `client/client-details/${clientID}`);
  }

  deleteClientFormApi(clientID: any) {
    return this.http.post(this.baseUrl + `client/delete-client/${clientID}`, {});
  }

  updateClientStatusApi(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'client/update-client-status', payload);
  }

  bulkUpdateClientApi(payload: any) {
    return this.http.post(this.baseUrl + 'client/bulk-update-client', payload);
  }

  checkClientFormStatusApi(clientID: any) {
    return this.http.get(this.baseUrl + `client/check-client-status/${clientID}`);
  }

  // client form submit
  saveClientAssessment(payload: any) {
    return this.http.post(this.baseUrl + 'client/save-client-assessment', payload);
  }

  saveFormResult(payload: any) {
    return this.http.post(this.baseUrl + 'client/form-result', payload);
  }

  fetchFormResult(payload: any) {
    return this.http.post(this.baseUrl + 'client/fetch-result', payload);
  }

  // Dashboard API

  dashboardCounts(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'dashboard/all-counts', payload);
  }

  //Section API
  sectionList(payload: any) {
    return this.http.post(this.baseUrl + 'form/section/section-list', payload);
  }

  //Domain API
  domainList(payload: any) {
    return this.http.post(this.baseUrl + 'form/domain/domain-list', payload);
  }


  reportDetails(payload: any) {
    return this.http.post(this.baseUrl + 'report/report-details', payload);
  }

  generatePDF(payload: any) {
    return this.http.post(this.baseUrl + 'report/convert-pdf', payload);
  }


  // Client Relative API
  saveClientRelative(payload: any) {
    return this.http.post(this.baseUrl + 'client/save-relative', payload);
  }

  saveClientObserver(payload: any) {
    return this.http.post(this.baseUrl + 'client/save-observers', payload);
  }
  
  checkRelativeStatusApi(clientID: any) {
    return this.http.get(this.baseUrl + `client/relative-status/${clientID}`);
  }

  checkRelativeDetailsApi(clientID: any) {
    return this.http.get(this.baseUrl + `client/relative-details/${clientID}`);
  }

  //Reset Form
  resetForm(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `client/${id}/reset-form-result`, payload);
  }

  //Notification API
  notiFicationList(): Observable<any> {
    return this.http.get(this.baseUrl + `notification/notification-list`);
  }

  markNotificationAsRead(id: string): Observable<any> {
    return this.http.post(this.baseUrl + `notification/${id}/read-notification`, {});
  }

  markAllNotificationsAsRead(): Observable<any> {
    return this.http.post(this.baseUrl + 'notification/read-all-notification', {});
  }

  hardDeleteUser(userId: string): Observable<any> {
    return this.http.post(this.baseUrl + `user/${userId}/hard-delete`, {});
  }

}
